import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import './NavAero.css';

const NavAero = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (to) => {
    // For Jobs, navigate directly to the Jobs page
    // if (to === "jobs") {
    //   navigate("/jobs");
    //   return;
    // }
    
    // If not on the main page, navigate there first
    if (location.pathname !== "/") {
      navigate("/");
      // Delay scrolling until the main page is loaded
      setTimeout(() => {
        const element = document.getElementById(to);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Adjust delay as needed for smooth transition
    } else {
      // If already on the main page, scroll directly to the section
      const element = document.getElementById(to);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleLogoClick = () => {
    // Reload the page if already on the main page
    if (location.pathname === "/") {
      window.location.reload();
    } else {
      navigate("/");
    }
  };
  

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      sticky="top"
      className="shadow-lg custom-navbar"
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand
          onClick={handleLogoClick}
          className="fw-bold fs-3 cursor-pointer"
        >
          GalaxyAdvisors
        </Navbar.Brand>

        {/* Toggle Button for Mobile */}
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        {/* Navbar Links */}
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              onClick={() => handleNavigation("about")}
              className="mx-2 btn-outline-light nav-custom"
            >
              About
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation("products")}
              className="mx-2 btn-outline-light nav-custom"
            >
              Products
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation("case-studies")}
              className="mx-2 btn-outline-light nav-custom"
            >
              Case Studies
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation("team")}
              className="mx-2 btn-outline-light nav-custom"
            >
              Team
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation("faq")}
              className="mx-2 btn-outline-light nav-custom"
            >
              FAQ
            </Nav.Link>
            <Nav.Link
              onClick={() => navigate("/jobs")}
              className="mx-2 btn-outline-light nav-custom"
            >
              Jobs
            </Nav.Link>
            <Nav.Link
              onClick={() => handleNavigation("contact")}
              className="mx-2 btn-outline-light nav-custom"
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavAero;
